export class AuthUser {

    constructor(properties) {
        Object.assign(this, properties);
    }

    isTeacher() {
        return this.type === 'teacher';
    }

    isStudent() {
        return this.type === 'student';
    }

    isAdmin() {
        return this.type === 'admin';
    }

    isExternal() {
        return this.type === 'external';
    }

    hasRoleOrAdmin(roles) {
        if (this.isAdmin()) {
            return true;
        }
        return this.hasRole(roles);
    }

    hasRole(roles) {
        if (!Array.isArray(roles)) {
            roles = [roles];
        }

        return this.roles
            .map((role) => role.name)
            .some((name) => roles.includes(name));
    }
}
